import { HttpRequest } from "../utils";

const httpRequest = new HttpRequest();

export const get = async (data: { date: any; rowDate: any; startDate: any; endDate: any }) => {
  return httpRequest.get(`/api/scf/dashboard`, data);
};
